import clsx from 'clsx';

const variants = {
  primary: 'fill-blue-100',
  secondary: 'fill-blue-700',
  tertiary: 'fill-blue-700',
  outlined: 'fill-blue-700',
  danger: 'fill-red-100',
  'danger-secondary': 'fill-red-700',
  minimal: 'fill-blue-700',
};

export interface QuarterSpinnerProps {
  variant?: keyof typeof variants;
}

export const QuarterSpinner = ({ variant = 'primary' }: QuarterSpinnerProps) => {
  // Ensure variant exists in our variants object, fallback to primary if not
  const safeVariant = variant in variants ? variant : 'primary';

  return (
    <svg className="w-7 h-7 animate-spin" viewBox="0 0 24 24">
      <path
        d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
        opacity=".25"
        className={clsx(variants[safeVariant])}
      />
      <path
        d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
        className={clsx(variants[safeVariant])}
      />
    </svg>
  );
};
